<template>
  <div id="app">
    <router-view/>
    <cookie-agreement></cookie-agreement>
    <alert />
  </div>
</template>

<script>
import createAuthRefreshInterceptor from 'axios-auth-refresh';
import Alert from '@/components/Alert.vue'
import CookieAgreement from '@/components/cookieAgreement.vue'

export default {
  name: 'App',
  components: {
    Alert,
    CookieAgreement
  },
  computed:{
    api(){
      return this.$store.state.api;
    },
    navMobile(){
      return this.$store.state.mobileNav;
    }
  },
  created(){
    this.$store.commit('changeRoute', this.$route.name);
    this.getPacketsData();
    this.setMonthPeriod();
    this.setPacket();
    let self = this;
    const refreshAuthLogic = failedRequest => this.axios.get(self.api + 'auth/token', { headers: { Authorization: localStorage.refreshToken } }).then(tokenRefreshResponse => {
      if(tokenRefreshResponse.data.status == 1){
        localStorage.accessToken = tokenRefreshResponse.data.accessToken;
        failedRequest.response.config.headers['Authorization'] = tokenRefreshResponse.data.accessToken;
        return Promise.resolve();
      }else{
        self.logout();
      }
    });

    createAuthRefreshInterceptor(this.axios, refreshAuthLogic, {
      statusCodes: [401],
      pauseInstanceWhileRefreshing: false,
    });

    this.axios.interceptors.request.use(request => {
        let path1 = self.api + 'auth/token';
        if(request.url != path1){
          request.headers['Authorization'] = self.getAccessToken();
        }
        return request;
    });
  },
  watch: {
    $route(to, from) {
      if(this.navMobile == 1){
        this.$store.commit('toggleMobileNav');
        document.body.style = "overflow-y: overlay";
      }
      this.$store.commit('changeRoute', this.$route.name);
      if(to.name == "PacketAdvantage"){
        let elmnt = document.getElementById("packet-minimalization");
        elmnt.scrollIntoView();
      }
      if(from.name == "Step1" && to.name == "Step2") {
        let step2State;
        if(localStorage.step2State) {
          step2State = JSON.parse(localStorage.step2State);
        } else {
          step2State = {};
        };
        step2State.logAndNipVisible = true;
        step2State.gusDataVisible = false;
        step2State.additionalDataVisible = false;
        step2State.registerAndRegulationsVisible = false;
        localStorage.setItem('step2State', JSON.stringify(step2State));
      }
    }
  },
  methods: {
    getPacketsData(){
      let self = this;
      this.axios
      .get(this.api + 'service/vo')
      .then(response => {
        let prices = {
          mini: [],
          standard: [],
          komfort: [],
        }
        for(let i = 0; i < response.data.data.length; i++){
          if(response.data.data[i].name == 'mini'){
            prices.mini.push(response.data.data[i].price_netto)
          }else if(response.data.data[i].name == 'standard'){
            prices.standard.push(response.data.data[i].price_netto)
          }else{
            prices.komfort.push(response.data.data[i].price_netto)
          }
        }
        prices.mini.sort((a, b) => b - a);
        prices.standard.sort((a, b) => b - a);
        prices.komfort.sort((a, b) => b - a);
        for(let i = 0; i < prices.mini.length; i++){
          prices.mini[i] = prices.mini[i].replace('.', ',')
        }
        for(let i = 0; i < prices.standard.length; i++){
          prices.standard[i] = prices.standard[i].replace('.', ',')
        }
        for(let i = 0; i < prices.komfort.length; i++){
          prices.komfort[i] = prices.komfort[i].replace('.', ',')
        }
        this.$store.commit('changePacketPrices', prices);
      });
    },
     logout(){
      this.$store.commit('changeLoggedIn', 0);
      localStorage.removeItem("accessToken");
      localStorage.removeItem("refreshToken");
      this.$router.push('/');
    },
    getAccessToken(){
      return localStorage.getItem('accessToken');
    },
    setMonthPeriod(){
      if(typeof localStorage.period == 'undefined'){
        this.$store.commit('changeMonth', 0);
      }else{
        this.$store.commit('changeMonth', localStorage.period);
      }
    },
    setPacket(){
      if(typeof localStorage.packet == 'undefined'){
        this.$store.commit('changePacket', 1);
      }else{
        this.$store.commit('changePacket', localStorage.packet);
      }
    }
  },
}
</script>

<style lang="scss">
  @import './styles/aspergit.css';

  * { box-sizing: border-box; }
  html { height: 100%; }
  body { height: 100%; margin: 0; padding: 0; font-family: 'Poppins', sans-serif; overflow-y: overlay; }
  div#app { height: 100%; }

  header.landing-default { margin: 30px 15px 30px 15px; }
  header.landing-default h3 { margin: 0; padding: 0; font-weight: 500; color: #616161; font-size: 30px; text-align: center; font-family: 'Open Sans Condensed', sans-serif; font-family: 'Poppins', sans-serif;  }
  header.landing-default h5 { margin: 15px auto 0 auto; padding: 0; font-weight: 400; color: $fontGray; font-size: 18px; text-align: center; line-height: 30px; }

  a.default { display: inline-block; padding: 14px 35px; font-size: 16px; background: $orangeDark; text-decoration: none; color: #fff; border-radius: 4px;  }
  a.default.disabled { background: $grayLighter; }
  a.default:hover { padding: 12px 33px; background: #fff; border: 2px solid $orangeDark; color: $orangeDark; }
  a.default.disabled:hover {  padding: 14px 35px; background: $grayLighter; border: 0; color: #fff; }
  a.default.reverse { padding: 12px 33px; background: #fff; color: $orangeDark; border: 2px solid $orangeDark;  }
  a.default.reverse:hover { background: $orangeDark; border: 2px solid $orangeDark; color: #fff; }
  button.default { display: inline-block; padding: 14px 35px; font-size: 16px; border: 0; outline: 0; background: $orangeDark; text-decoration: none; color: #fff; 
    border-radius: 4px; cursor: pointer; }
  button.default.gray { background: $grayLighter; cursor: default; }
  button.default.gray:focus { outline: 0; }
  button.default.gray:hover { padding: 14px 35px; background: $grayLighter; border: 0px; color: #fff; }
  button.default.black { background: $blackLight;  cursor: default; }
  button.default.black.small:hover { background: #fff; border: 2px solid $blackLight; color: $blackLight; }
  button.default.small { padding: 10px 31px; font-size: 14px; cursor: pointer;}
  button.default:focus { outline: 0; }
  button.default:hover { padding: 12px 33px; background: #fff; border: 2px solid $orangeDark; color: $orangeDark; }
  button.default.small:hover { padding: 8px 29px; }
  button.default.reverse { padding: 12px 33px; background: #fff; color: $orangeDark; border: 2px solid $orangeDark; }
  button.default.reverse.active { background: $orangeDark; border: 2px solid $orangeDark; color: #fff; }
  button.default.reverse.small { padding: 6px 27px; font-size: 14px; }
  button.default.reverse:focus { outline: 0; }
  button.default.reverse:hover { background: $orangeDark; border: 2px solid $orangeDark; color: #fff; }

  header.subpage { display: flex; flex-direction: column; align-items: center; height: 350px; margin-top: 60px; padding-top: 50px; 
    background: url('assets/banner_half.jpg') no-repeat 50% 50%; background-size: 100% 100%; }
  header.subpage h3 { margin: 0 0 25px 0; padding: 0; font-family: 'Aspergit Regular', sans-serif; color: #fff; font-size: 100px; text-shadow: 7px 7px 10px #221f1f; 
    letter-spacing: 2px; font-weight: 500; text-align: center; }
  header.subpage h4 { margin: 0; padding: 0; font-family: 'Aspergit Regular', sans-serif; color: #fff; font-size: 32px; text-shadow: 2px 2px 3px #221f1f; 
    letter-spacing: 2px; font-weight: 500; text-transform: uppercase; text-align: center; }
  header.subpage h3 span { font-family: 'Raleway', sans-serif; font-weight: 200; font-size: 96px; }
  header.subpage h4 span { font-family: 'Raleway', sans-serif; font-weight: 200; font-size: 33px; }
  
  div.subpage-top { background: rgb(114,137,218); background: linear-gradient(135deg, rgba(114,137,218,1) 0%, rgba(52,38,173,1) 49%, rgba(199,99,223,1) 100%); }
  div.subpage-top header { display: flex; flex-direction: column; justify-content: center; align-items: center; height: 350px; }
  div.subpage-top header h3 { margin: 0; padding: 0; color: #fff; font-weight: 500; font-size: 75px; text-align: center; }
  div.subpage-top header h4 { margin: 20px 0; padding: 0; color: rgba(255, 255, 255, 0.8); font-weight: 400; text-transform: uppercase; letter-spacing: 5px; 
    font-size: 15px; text-align: center; }

  div.step { display: flex; flex-direction: column; align-items: center; width: 160px; }
  div.step div.number { display: flex; flex-direction: column; justify-content: center; height: 87px; margin: 0 0 6px 0; }
  div.step div.number div.circle { display: flex; flex-direction: column; justify-content: center; align-items: center; width: 87px; height: 87px;  
    border-radius: 50%; border: 2px solid $grayLight; }
  div.step div.number div.circle p { margin: 0; padding: 0; color: $grayLight; font-size: 28px; font-weight: 400; }
  div.step h6 { margin: 20px 0 0 0; padding: 0; color: $grayLight; font-weight: 500; font-size: 16px; }
  div.step-line { width: 200px; height: 2px; margin: 43.5px -10px 0 -10px; background: $grayLight; }
  a { text-decoration: none; }
  a div.step div.number div.circle { border-color: $orangeDark; }
  a div.step div.number div.circle p { color: $orangeDark; }
  a div.step h6 { color: $orangeDark; }

  section.order { height: 100%; }
  section.order header.main { margin: 120px 0 60px 0; }
  section.order div.wrapper { height: 100%; padding: 50px; background: #f2f2f2; }
  section.order div.wrapper > div.content { width: 1000px; margin: 0 auto; padding: 10px 30px; background: #fff; border-radius: 3px; }
  section.order div.content section { margin: 10px 0; margin-bottom: 20px; padding-bottom: 15px; border-bottom: 1px solid #e5e5e5; }
  section.order div.content section:last-child { border: 0; margin-bottom: 10px; padding-bottom: 0; }
  section.order div.content section header.flex { display: flex; justify-content: space-between; align-items: center; margin: 0; }
  section.order div.content section header h4 { margin: 0; margin-bottom: 15px; padding: 0; color: $grayLight; font-weight: 500; font-size: 20px; }
  section.order div.content section header h5 { margin: 0; padding: 0; color: $grayLight; font-weight: 400; font-size: 14px; }
  section.order div.content section header p { margin: 0; padding: 3px 10px; font-size: 14px; color: $orangeDark; cursor: pointer; text-align: right; }
  section.order div.content section header p:hover { background: $orangeDark; color: #fff; border-radius: 3px; }

  input.data { display: block; width: 100%; height: 40px; padding: 0 10px 0 10px; border-radius: 5px; outline: 0; border: 0; border: 1px solid rgba(0, 0, 0, 0.1); 
    color: $fontBlack; font-size: 15px; font-family: 'Poppins', sans-serif; }
  input.data::placeholder { color: rgba(0, 0, 0, 0.5); }
  input.data:focus { border: 1px solid $orangeDark;  }
  input.data.error { padding: 0 44px 0 10px; border: 1px solid $fontRed; }
  textarea.data { display: block; width: 100%; padding: 10px 44px 10px 10px; border-radius: 5px; outline: 0; border: 0; border: 1px solid rgba(0, 0, 0, 0.1); 
    color: $fontBlack; font-size: 15px; font-family: 'Poppins', sans-serif; }
  textarea.data::placeholder { color: rgba(0, 0, 0, 0.5);  }

  div.input-container p { margin: 3px 0 0 0; padding: 0 11px; color: $fontRed;; font-size: 11px; }
  div.input-container div.input-box { width: calc(100% - 40px); height: 40px; position: relative; }
  div.input-container div.input-box input { width: calc(100% - 40px); }
  div.input-container div.input-box i.material-icons { display: block; width: 24px; height: 24px; font-size: 24px; 
    position: absolute; top: calc(20px - 12px); right: 10px; color: $fontRed; }

  @media (max-width: 1200px) {
    div.step { width: 140px; }
    div.step div.number { height: 77px; margin: 0 0 6px 0; }
    div.step div.number div.circle { width: 77px; height: 77px;  }
    div.step div.number div.circle p { font-size: 24px; }
    div.step h6 { margin: 20px 0 0 0; font-size: 14px; }
    div.step-line { width: 120px; height: 2px; margin: 43.5px -10px 0 -10px; }
  }

  @media (max-width: 1100px) {
    header.landing-default { margin: 30px 15px 30px 15px; }
    header.landing-default h3 { font-size: 26px; }
    header.landing-default h5 { font-size: 16px; }
    header.subpage { height: 400px; margin-top: 60px; padding-top: 50px; background: url('assets/banner_1100x400.webp') no-repeat 50% 50%; }
    header.subpage h3 { margin: 0 0 25px 0; font-size: 70px; }
    header.subpage h4 { font-size: 24px; }
    header.subpage h3 span { font-weight: 200; font-size: 67px; }
    header.subpage h4 span { font-weight: 200; font-size: 24px; }
    section.order div.wrapper { height: 100%; padding: 20px; background: #f2f2f2; }
    section.order div.wrapper > div.content { width: calc(100vw - 40px); }
  }

  @media (max-width: 850px) {
    div.step { width: 140px; margin: 20px; }
    div.step div.number { height: 77px; margin: 0 0 6px 0; }
    div.step div.number div.circle { width: 77px; height: 77px;  }
    div.step div.number div.circle p { font-size: 24px; }
    div.step h6 { margin: 20px 0 0 0; font-size: 14px; }
    div.step-line { display: none; }

    section.order header.main { margin: 80px 0 20px 0; }
  }

  @media (max-width: 700px) {
    header.landing-default { margin: 30px 15px 30px 15px; }
    header.landing-default h3 { font-size: 22px; }
    header.landing-default h5 { font-size: 14px; }
    header.subpage h3 { margin: 0 0 25px 0; font-size: 50px; }
    header.subpage h4 { font-size: 17px; }
    header.subpage h3 span { font-weight: 200; font-size: 47px; }
    header.subpage h4 span { font-weight: 200; font-size: 18px; }

    a.default { padding: 12px 30px; font-size: 14px; }
    a.default:hover { padding: 10px 29px;  }
    a.default.disabled:hover { padding: 12px 30px; }
    a.default.reverse { padding: 12px 33px;  }
    button.default { padding: 12px 30px; font-size: 14px;  }
    button.default.small { padding: 10px 31px; font-size: 14px; }
    button.default:hover { padding: 10px 29px; }
    button.default.reverse { padding: 10px 29px; }
    button.default.reverse.small { padding: 6px 27px; font-size: 14px; }

    section.order div.content section header.flex { display: block; }
    section.order div.content section header h4 { text-align: center; }
    section.order div.content section header p { margin-top: 10px; text-align: center; }
  }

  @media (max-width: 400px) {
    header.subpage { height: 300px; background: url('assets/banner_400x300.webp') no-repeat 50% 50%; }
    header.subpage h3 { font-size: 40px; }
    header.subpage h4 { font-size: 18px; }
  }

  @keyframes shadowChangeWhite {
    0%   { box-shadow: 0px 0px 3px #fff; }
    25%  { box-shadow: 0px 0px 7px #fff; }
    50%  { box-shadow: 0px 0px 12px #fff; }
    75%  { box-shadow: 0px 0px 7px #fff; }
    100% { box-shadow: 0px 0px 3px #fff; }
  }

  ::-webkit-scrollbar { width: 8px; height: 8px; }
  ::-webkit-scrollbar-button { width: 0px; height: 0px; }
  ::-webkit-scrollbar-thumb { background: $grayLighter; border: 0px none #ffffff; border-radius: 100px; }
  ::-webkit-scrollbar-thumb:hover { background: $grayLighter; }
  ::-webkit-scrollbar-thumb:active { background: $grayLighter; }
  ::-webkit-scrollbar-track { background: transparent; border: 0px none #ffffff; border-radius: 100px; }
  ::-webkit-scrollbar-track:hover { background: transparent; }
  ::-webkit-scrollbar-track:active { background: transparent; }
  ::-webkit-scrollbar-corner { background: transparent; }
</style>
